export const FLAG_GETTING_CABIN_CREW_MOVEMENT_HISTORY =
  'FLAG_GETTING_CABIN_CREW_MOVEMENT_HISTORY';
export const GET_CABIN_CREW_MOVEMENT_HISTORY_LIST = 'GET_CABIN_CREW_MOVEMENT_HISTORY_LIST';
export const CLEAR_CABIN_CREW_MOVEMENT_HISTORY_LIST = 'CLEAR_CABIN_CREW_MOVEMENT_HISTORY_LIST';
export const FLAG_CABIN_CREW_MOVEMENT_HISTORY_ACTIVITY =
  'FLAG_CABIN_CREW_MOVEMENT_HISTORY_ACTIVITY';
export const GET_CABIN_CREW_MOVEMENT_HISTORY = 'GET_CABIN_CREW_MOVEMENT_HISTORY';
export const CLEAR_CABIN_CREW_MOVEMENT_HISTORY = 'CLEAR_CABIN_CREW_MOVEMENT_HISTORY';
export const POST_CABIN_CREW_MOVEMENT_HISTORY = 'POST_CABIN_CREW_MOVEMENT_HISTORY';
export const PUT_CABIN_CREW_MOVEMENT_HISTORY = 'PUT_CABIN_CREW_MOVEMENT_HISTORY';